const dataDomainScript = "ea9f97f6-61c6-47ad-ad28-d3628d70bfe7";
export const getDataDomainScript = (): string => {
  if (
    typeof window !== "undefined" &&
    window.location.hostname === "www.beautypie.com"
  ) {
    return dataDomainScript;
  }

  return `${dataDomainScript}-test`;
};
